var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Contact Email")]),_c('div',{staticClass:"control"},[_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"..."},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"focusout":_vm.handleChange}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }